<template>
  <div>
    <div>
      <Titulo :titulo="'Informes - ' + routeName" />
    </div>
    <!-- coger el parametro que se envio por la ruta -->
    <!-- {{$route.params.id}} -->
    <div class="margin-informes">
      <p class="mb-5 text-justify">
        Ingresar número de convenio, estado y el rango de fechas que desea
        consultar.
      </p>

      <!--
        @props
            data: Array,            required: true
            pagination: boolean,    required: false
            perPage: Number,        required: false
            SetectFiltro: Array     required: false
            filtro: boolean         required: false
      -->
      <table-component
        :data="data"
        @click-buscar="buscar"
        @click-event="clickEvent"
        pagination
        filtro
        showExportToExcel
        :showFilterDates="true"
        :perPage="perPage"
        :dataLength="dataLength"
        showFilterConvenios
        :Convenios="convenios"
        showFilterEstadoGarantia
        :EstadoGarantia="EstadoGarantia"
      >
        <table-column
          slot="label"
          :label="'Archivo'"
          v-bind:value="'archivo'"
          :customClass="'text-center'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Modelo'"
          v-bind:value="'modelo'"
          :customClass="'text-center'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Estado'"
          v-bind:value="'estado'"
          :customClass="'text-center'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Registros buenos'"
          v-bind:value="'registros_buenos'"
          :customClass="'text-center'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Registros malos'"
          v-bind:value="'registros_malos'"
          :customClass="'text-center'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Registros totales'"
          v-bind:value="'total_registros'"
          :customClass="'text-center'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Saldo a Transferir'"
          v-bind:value="'disponible'"
          :customClass="'text-center'"
          :filter="'numberFormat'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Acciones'"
          :customClass="'text-center'"
        >
          <table-column
            slot="icon"
            :icon="'fa fa-search-plus'"
            :class="'btn btn-sm btn-info'"
            :slug="'AmpliarInformacion'"
            :tooltip="'Ampliar información'"
          ></table-column>
        </table-column>
      </table-component>
      <b-modal id="modal-1" title="Detalle compra/venta" hide-footer size="xl">
        <div class="m-1" v-if="this.total_detalle > 0">
          <h3 class="color-secundary">
            Información de la compra/venta de cartera
          </h3>
          <div class>
            <div class="container">
              <br />
              <h4
                v-if="
                  this.comprador == this.$store.state.user.user.sigBanco.nit
                "
              >
                Vendedor:
                {{ this.vendedor_abr }}
              </h4>
              <h4
                v-if="
                  this.comprador != this.$store.state.user.user.sigBanco.nit
                "
              >
                Comprador:
                {{ this.comprador_abr }}
              </h4>
              <h4
                v-if="
                  this.comprador == this.$store.state.user.user.sigBanco.nit
                "
              >
                Usuario aprueba:
                {{ this.nombre_usuario_compra }}
              </h4>
              <h4>
                Valor a Transferir:
                {{ this.disponible ? this.disponible : 0 }}
              </h4>
              <br />
              <div
                class="form-group"
                v-if="
                  convenios.length > 0 &&
                  this.comprador == this.$store.state.user.user.sigBanco.nit &&
                  this.estado != 'FINALIZADO'
                "
              >
                <label
                  class="control-label col-lg-3 col-md-2"
                  v-text="'Código'"
                ></label>
                <div class="col-lg-12 col-md-12">
                  <select
                    @change="setProducto()"
                    class="form-control"
                    id="datos_convenios"
                    v-model="sig_convenio_id"
                    required
                  >
                    <option
                      v-for="convenio in convenios"
                      :key="convenio.value"
                      :value="convenio.value"
                    >
                      {{ convenio.text }}
                    </option>
                  </select>
                </div>
              </div>

              <div
                class="form-group"
                v-if="
                  productos.length > 0 &&
                  this.comprador == this.$store.state.user.user.sigBanco.nit
                "
              >
                <label
                  class="control-label col-lg-3 col-md-2"
                  v-text="'Producto'"
                ></label>
                <div class="col-lg-12 col-md-12">
                  <select
                    class="form-control"
                    id="datos_productos"
                    v-model="sig_producto_id"
                  >
                    <option :value="null">Seleccione el producto</option>
                    <option
                      v-for="producto in productos"
                      :key="producto.id"
                      :value="producto.id"
                      required
                    >
                      Producto {{ producto.alias }}
                    </option>
                  </select>
                </div>
              </div>
              <br />
              <table-component
                :data="this.detalle"
                :dataLength="this.total_detalle"
                pagination
                :perPage="5"
                @click-event="clickEventDetalle"
                showExportToExcel
              >
                <table-column
                  slot="label"
                  :label="'Nit entidad venta'"
                  v-bind:value="'Nit_entidad_que_realiza_la_venta'"
                  :customClass="'text-center'"
                ></table-column>
                <table-column
                  slot="label"
                  :label="'Cedula'"
                  v-bind:value="'Número_documento_deudor'"
                  :customClass="'text-center'"
                ></table-column>
                <table-column
                  slot="label"
                  :label="'Pagaré'"
                  v-bind:value="'Número_de_pagaré'"
                  :customClass="'text-center'"
                ></table-column>
                <table-column
                  slot="label"
                  :label="'Nombre cliente'"
                  v-bind:value="'Nombre_del_cliente'"
                  :customClass="'text-center'"
                ></table-column>
                <table-column
                  slot="label"
                  :label="'Fecha venta'"
                  v-bind:value="'Fecha_de_venta'"
                  :customClass="'text-center'"
                ></table-column>
                <table-column
                  slot="label"
                  :label="'Saldo Capital'"
                  v-bind:value="'Saldo_capital_operación_vendida'"
                  :customClass="'text-center'"
                  :filter="'numberFormat'"
                ></table-column>
                <table-column
                  slot="label"
                  :label="'Saldo total'"
                  v-bind:value="'Saldo_total_de_la_operacion_vendida'"
                  :customClass="'text-center'"
                  :filter="'numberFormat'"
                ></table-column>
                <table-column
                  slot="label"
                  :label="'Fecha corte'"
                  v-bind:value="'Fecha_de_corte'"
                  :customClass="'text-center'"
                ></table-column>

                <table-column
                  slot="label"
                  :label="'Fecha inicio mora'"
                  v-bind:value="'Fecha_de_inicio_de_mora'"
                  :customClass="'text-center'"
                ></table-column>
              </table-component>

              <b-row
                v-if="
                  this.comprador == this.$store.state.user.user.sigBanco.nit
                "
              >
                <b-col sm="12" class="text-center">
                  <b-button
                    variant="outline-success"
                    :disabled="
                      this.registros_malos > 0 ||
                      loading ||
                      this.registros_buenos != this.total_registros ||
                      this.estado == 'FINALIZADO' ||
                      this.sig_producto_id == null
                    "
                    block
                    @click="ejecutarVentaCompra"
                  >
                    <i class="fa fa-check"></i> Aprobar Compra/Venta
                  </b-button>
                </b-col>
              </b-row>
              &nbsp;
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import SelectNovedad from "@/data/SelectQueEsNovedad.json";
import SelectTipoNovedad from "@/data/SelectTipoNovedad.json";

import XLSX from "xlsx";
import { saveAs } from "file-saver";

export default {
  name: "SubirInformes",
  data() {
    return {
      SelectNovedad: SelectNovedad,
      SelectTipoNovedad: SelectTipoNovedad,
      selectQueEsNovedad: "",
      selectTipoNovedad: "",
      EstadoGarantia: [
        { value: null, text: "Seleccione" },
        { value: 23, text: "Vigente Compra Cartera" },
        { value: 24, text: "Cancelada Venta Cartera" },
        { value: 26, text: "Pagada Compra Cartera" },
        { value: 31, text: "Cancelacion Total Compra Cartera" },
        { value: 33, text: "Recuperada Parcial Compra Cartera" },
        { value: 34, text: "Recuperada Total Compra Cartera" },
      ],
      perPage: 25,
      informe_url: "portal/cargues/venta_cartera",
      convenio: null,
      fecha_fin: null,
      fecha_inicio: null,
      estadoGarantiaSelected: null,
      filename: "Venta compra cartera ",
      detalle: [],
      disponible: null,
      total_detalle: 0,
      id_detalle: null,
      sig_convenio_id: null,
      productos: [],
      sig_producto_id: null,
      comprador_abr: null,
      vendedor_abr: null,
      nombre_usuario_compra: null,
    };
  },
  components: {
    Titulo: () => import("@/containers/layout/Titulo.vue"),
    TableComponent: () => import("@/components/table/TableComponent"),
    TableColumn: () => import("@/components/table/TableColumn"),
  },
  computed: {
    ...mapGetters({
      TablaVerProducto: "pages/TablaVerProducto",
      loading: "loading",
    }),
    convenios() {
      let data = this.$store.getters["pages/convenios"].map((convenio) => {
        return { value: convenio.id, text: convenio.nombre_convenio };
      });
      data.unshift({ value: null, text: "Código", disabled: true });
      return data;
    },
    dataLength() {
      return this.$store.getters["pages/total"];
    },
    data() {
      return this.$store.getters["pages/dataInformes"];
    },
    routeName() {
      return this.$router.currentRoute.name;
    },
  },
  methods: {
    buscar(params) {
      this.fecha_inicio = params.fecha_inicio;
      this.fecha_fin = params.fecha_fin;
      this.convenio = params.convenio;
      this.estadoGarantiaSelected = params.filterEstadoGarantiaSelected;
      this.loadData();
    },
    async clickEvent(data, slug) {
      switch (slug) {
        case "paginacion":
          this.loadData(data.nRows, data.page);
          break;
        case "AmpliarInformacion":
          this.id_detalle = data.id;
          this.$store.commit("SET_LOADING", true);
          try {
            let response = await this.$store.state.api.post(
              "portal/cargues/venta_cartera/registros",
              { id: this.id_detalle, page: 1, row: 5, paginar: 1 }
            );

            this.detalle = response.data.datos.datos;
            let _response = response.data.datos;
            const formatter = new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              minimumFractionDigits: 0,
            });

            let total_disponible = 0;
            let disponible_array = null;

            if (_response.disponible.length !== undefined) {
              disponible_array = _response.disponible;
            } else {
              disponible_array = JSON.parse(_response.disponible);
            }

            disponible_array.forEach((value) => {
              total_disponible = +total_disponible + +value.disponible;
            });

            this.disponible = formatter.format(total_disponible);
            this.registros_buenos = _response.registros_buenos;
            this.registros_malos = _response.registros_malos;
            this.total_registros = _response.total_registros;
            this.total_detalle = response.data.total;
            this.estado = _response.estado;
            this.comprador = _response.comprador;
            this.nombre_usuario_compra = _response.nombre_usuario_compra;

            if (this.comprador != this.$store.state.user.user.sigBanco.nit) {
              try {
                let banco_compra = await this.$store.state.api.get(
                  "intermediario",
                  {
                    params: {
                      nit: this.comprador,
                    },
                  }
                );
                this.comprador_abr = banco_compra.data.datos[0].nombre_abr;
              } catch {
                this.$toasted.show(
                  "Lo sentimos, ocurrió un error al intentar consultar la información",
                  {
                    theme: "toasted-primary",
                    position: "top-right",
                    duration: 10000,
                  }
                );
              }
            } else {
              try {
                let banco_vende = await this.$store.state.api.get(
                  "/intermediario",
                  {
                    params: {
                      nit: data.nit,
                    },
                  }
                );
                this.vendedor_abr = banco_vende.data.datos[0].nombre_abr;
              } catch {
                this.$toasted.show(
                  "Lo sentimos, ocurrió un error al intentar consultar la información",
                  {
                    theme: "toasted-primary",
                    position: "top-right",
                    duration: 10000,
                  }
                );
              }
            }
          } catch (err) {
            this.$root.$emit("bv::hide::modal", "modal-1", "#btnShow");
            this.$toasted.show(
              "Lo sentimos, ocurrió un error al intentar consultar la información",
              {
                theme: "toasted-primary",
                position: "top-right",
                duration: 10000,
              }
            );
          }

          this.$store.commit("SET_LOADING", false);
          this.$root.$emit("bv::show::modal", "modal-1", "#btnShow");
          break;
        case "export-to-excel":
          this.$toasted.show("Por favor espere mientras exportamos los datos", {
            theme: "toasted-primary",
            position: "top-center",
            duration: 5000,
          });
          this.$store.commit("SET_LOADING", true);
          try {
            let result = await this.$store.state.api.get(this.informe_url, {
              params: {
                paginar: 0,
                convenio: this.convenio,
                codigo: this.estadoGarantiaSelected,
                fecha_compra_venta_inicial: this.fecha_inicio,
                fecha_compra_venta_final: this.fecha_fin,
              },
            });
            let total = 0;
            let disp = null;
            result.data.datos.forEach((element, index) => {
              total = 0;
              if (element.disponible.length) {
                disp = element.disponible;
              } else {
                if (element.disponible.length) {
                  disp = JSON.parse(element.disponible);
                }
              }

              if (disp.length) {
                disp.forEach((value) => {
                  if (value.disponible) {
                    total = total + parseInt(value.disponible);
                  }
                });
              }
              result.data.datos[index].disponible = total;
            });
            let data = XLSX.utils.json_to_sheet(result.data.datos, {
              header: [
                "id",
                "modelo",
                "archivo",
                "estado",
                "registros_buenos",
                "registros_malos",
                "total_registros",
                "disponible",
              ],
            });

            data["A1"].v = "id";
            data["B1"].v = "Modelo";
            data["C1"].v = "Archivo";
            data["D1"].v = "Estado";
            data["E1"].v = "Registros buenos";
            data["F1"].v = "Registros malos";
            data["G1"].v = "Total registros";
            data["H1"].v = "Saldo a Transferir";

            var workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, data, this.fileName);
            var wopts = { bookType: "xlsx", bookSST: false, type: "array" };
            var wbout = XLSX.write(workbook, wopts);
            var today = new Date();
            var dd = today.getDate();

            var mm = today.getMonth() + 1;
            var yyyy = today.getFullYear();

            if (dd < 10) {
              dd = "0" + dd;
            }

            if (mm < 10) {
              mm = "0" + mm;
            }

            today = dd + "/" + mm + "/" + yyyy;
            saveAs(
              new Blob([wbout], { type: "application/octet-stream" }),
              this.filename + today + ".xlsx"
            );
            this.$toasted.show("El archivo fue exportado exitosamente", {
              theme: "toasted-primary",
              position: "top-right",
              duration: 10000,
            });
          } catch (err) {
            this.$toasted.show(
              "Ocurrió un error al intentar exportar el archivo",
              {
                theme: "toasted-primary",
                position: "top-right",
                duration: 10000,
              }
            );
          }
          this.$store.commit("SET_LOADING", false);
          break;
      }
    },
    async clickEventDetalle(data, slug) {
      switch (slug) {
        case "export-to-excel":
          this.$toasted.show("Por favor espere mientras exportamos los datos", {
            theme: "toasted-primary",
            position: "top-center",
            duration: 5000,
          });
          this.$store.commit("SET_LOADING", true);
          try {
            let result = await this.$store.state.api.post(
              "portal/cargues/venta_cartera/registros",
              {
                id: this.id_detalle,
              }
            );
            let data = XLSX.utils.json_to_sheet(result.data.datos.datos);
            var workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(
              workbook,
              data,
              "Detalle_Venta_Cartera "
            );
            var wopts = { bookType: "xlsx", bookSST: false, type: "array" };
            var wbout = XLSX.write(workbook, wopts);
            var today = new Date();
            var dd = today.getDate();
            var mm = today.getMonth() + 1;
            var yyyy = today.getFullYear();

            if (dd < 10) {
              dd = "0" + dd;
            }

            if (mm < 10) {
              mm = "0" + mm;
            }

            today = dd + "/" + mm + "/" + yyyy;
            saveAs(
              new Blob([wbout], { type: "application/octet-stream" }),
              "Detalle_Venta_Cartera " + today + ".xlsx"
            );
            this.$toasted.show("El archivo fue exportado exitosamente", {
              theme: "toasted-primary",
              position: "top-right",
              duration: 10000,
            });
          } catch (err) {
            this.$toasted.show(
              "Ocurrió un error al intentar exportar el archivo",
              {
                theme: "toasted-primary",
                position: "top-right",
                duration: 10000,
              }
            );
          }
          this.$store.commit("SET_LOADING", false);
          break;
        case "paginacion":
          this.$store.commit("SET_LOADING", true);
          try {
            let response = await this.$store.state.api.post(
              "portal/cargues/venta_cartera/registros",
              {
                id: this.id_detalle,
                page: data.page,
                row: data.nRows,
                paginar: 1,
              }
            );

            this.detalle = response.data.datos.datos;
          } catch (err) {
            this.$root.$emit("bv::hide::modal", "modal-1", "#btnShow");
            this.$toasted.show(
              "Lo sentimos, ocurrió un error al intentar consultar la información",
              {
                theme: "toasted-primary",
                position: "top-right",
                duration: 10000,
              }
            );
          }

          this.$store.commit("SET_LOADING", false);
          break;
      }
    },
    async setProducto() {
      this.$store.commit("SET_LOADING", true);
      this.productos = [];
      let response = await this.$store.state.api.get("/producto", {
        params: {
          sig_convenio_id: [this.sig_convenio_id],
        },
      });

      this.productos = response.data.datos;
      this.$store.commit("SET_LOADING", false);
    },
    async loadData(row, page, paginar = 1) {
      this.productos = [];
      await this.$store.dispatch("pages/fetch", {
        endpoint: this.informe_url,
        params: {
          row: this.perPage,
          page: page ? page : 1,
          paginar: paginar,
          convenio: this.convenio,
          codigo: this.estadoGarantiaSelected,
          fecha_compra_venta_inicial: this.fecha_inicio,
          fecha_compra_venta_final: this.fecha_fin,
        },
      });
    },
    async ejecutarVentaCompra() {
      this.$root.$emit("bv::hide::modal", "modal-1", "#btnShow");
      this.$store.commit("SET_LOADING", true);
      try {
        if (this.sig_producto_id) {
          let result = await this.$store.state.api.post(
            "portal/cargues/venta_cartera/procesar",
            {
              id: this.id_detalle,
              sig_producto_id: this.sig_producto_id,
            }
          );

          if (result.data == "proceso finalizado.") {
            this.$toasted.show(
              "Se ha ejecutado correctamente la compra/venta de cartera",
              {
                theme: "toasted-primary",
                position: "top-right",
                duration: 10000,
              }
            );
            this.loadData(this.perPage, 1);
          } else {
            this.$toasted.show(
              "Por favor seleccione un producto de destino para las carteras",
              {
                theme: "toasted-primary",
                position: "top-right",
                duration: 10000,
              }
            );
          }
        } else {
          this.$toasted.show(
            "Lo sentimos, ocurrió un error al intentar procesar los datos",
            {
              theme: "toasted-primary",
              position: "top-right",
              duration: 10000,
            }
          );
        }
      } catch (err) {
        this.$toasted.show(
          "Lo sentimos, ocurrió un error al intentar procesar los datos",
          {
            theme: "toasted-primary",
            position: "top-right",
            duration: 10000,
          }
        );
      }
      this.$store.commit("SET_LOADING", false);
    },
  },
  watch: {
    data(newVal, oldVal) {
      let total = 0;
      let disp = null;

      newVal.forEach((element, index) => {
        total = 0;
        if (element.disponible.length) {
          disp = element.disponible;
        } else {
          if (element.disponible.length) {
            disp = JSON.parse(element.disponible);
          }
        }

        if (disp.length) {
          disp.forEach((value) => {
            if (value.disponible) {
              total = total + parseInt(value.disponible);
            }
          });
        }
        this.data[index].disponible = total;
      });
    },
  },
  mounted() {
    this.loadData(this.perPage, 1);
    if (this.$store.getters["pages/convenios"].length < 1) {
      this.$store.dispatch("pages/fetchConvenios", {
        endpoint: "portal/informes/convenio",
      });
    }
  },
};
</script>